module.exports = __webpack_public_path__ + "img/wximg37.c31b55da.png";